import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    playTest: {
        id: "planCard.playTest",
    },
    logInToGadgets: {
        id: "plan.logInToGadgets",
    },
    playShareTest: {
        id: "planCard.playShareTest",
    },
    modifiedRefresh: {
        id: "plan.modifiedRefresh",
    },
    metaFirst: {
        id: "plan.metaFirst",
    },
    attention: {
        id: "plan.attention",
    },
    profileToGadgets: {
        id: "planCard.profileToGadgets",
    },
    originalPlan: {
        id: "plan.originalPlan",
    },
    sharableAttention: {
        id: "plan.sharableAttention",
    },
    covidUse: {
        id: "plan.covidUse.singular",
    },
});

export default messages;
